import React from "react";

export default function RegisterClinicFormStep2() {
  return <div>RegisterClinicFormStep2</div>;
}
